<template>
  <div class="tickData" :class="isScroll?'':'isBackground'">
    <Header :title="title" :right-content="rightContent" @flashList="flashProductList" />
    <div id="content">
      <div class="layout">
        <div id="filterCon" class="filterCon">
          <ul>
            <li @click="foreignPop">
              <span>{{ tickData?tickData.chname:chname }}<em /></span>
              <p>产品 <i v-if="isPosition">(持仓）</i></p>
            </li>
            <li @click="selectTime">
              <span>{{ Utils.isNotEmpty(timeData)?new Date(timeData.replace(/-/g, "/")).format("Y-MM-dd hh:mm:ss"):"--" }}<em /></span>
              <p>报价时间(GMT+8时区)</p>
            </li>
          </ul>
        </div>
        <div class="tip"><p>此为交易所原始报价，不涉及平台点差，实际价格请依平台显示为准</p></div>
        <div class="proTit"><p>时间</p><p>买入</p><p>卖出</p></div>
        <div v-if="quoteList&&quoteList.length>0" class="proList">
          <ul>
            <li v-for="product in quoteList">
              <p>{{ product.priceTime }}</p>
              <p :class="classType(product.bidClass)"><span>{{ product.bid }}</span><em /></p>
              <p :class="classType(product.askClass)"><span>{{ product.ask }}</span><em /></p>
            </li>
          </ul>
          <div class="more">
            <img v-if="isPre" src="@/assets/images/template/nav_l_page.png" @click="clickPre">
            <img v-if="isNext" src="@/assets/images/template/nav_p_page.png" @click="clickNext">
          </div>
        </div>
        <noData v-else />
        <!--产品-->
        <div v-if="isForeign" class="proData">
          <div class="maxHeight" :style="{'max-height':maxHeight}">
            <div class="itemCon">
              <div class="itemTit">
                <span>外汇</span>
                <p :class="{checked:showAllFx}" @click="showAllFx = !showAllFx;">更多产品<em /></p>
              </div>
              <div class="itemUl">
                <ul>
                  <li v-for="product in filteredFxList" :key="'fx-' + product.code" :class="{checked:code==product.code}" @click="selectType(product)"><span>{{ product.chname }}</span></li>
                </ul>
              </div>
            </div>
            <div class="itemCon">
              <div class="itemTit">
                <span>商品</span>
                <p :class="{checked:showAllGoods}" @click="showAllGoods = !showAllGoods">更多产品<em /></p>
              </div>
              <div class="itemUl">
                <ul>
                  <li v-for="product in filteredGoodsList" :key="'commodity-' + product.code" :class="{checked:code==product.code}" @click="selectType(product)"><span>{{ product.chname }}</span></li>
                </ul>
              </div>
            </div>
            <div class="itemCon">
              <div class="itemTit">
                <span>指数</span>
                <p :class="{checked:showAllIndexs}" @click="showAllIndexs = !showAllIndexs">更多产品<em /></p>
              </div>
              <div class="itemUl">
                <ul>
                  <li v-for="product in filteredIndexList" :key="'index-' + product.code" :class="{checked:code==product.code}" @click="selectType(product)"><span>{{ product.chname }}</span></li>
                </ul>
              </div>
            </div>
            <div class="itemCon">
              <div class="itemTit">
                <span>股票</span>
                <p :class="{checked:showAllStocks}" @click="showAllStocks = !showAllStocks">更多产品<em /></p>
              </div>
              <div class="itemUl">
                <ul>
                  <li v-for="product in filteredStockList" :key="'stock-' + product.code" :class="{checked:code==product.code}" @click="selectType(product)"><span>{{ product.chname }}</span></li>
                </ul>
              </div>
            </div>
            <div class="itemCon">
              <div class="itemTit">
                <span>数字货币</span>
                <p :class="{checked:showAllCrypto}" @click="showAllCrypto = !showAllCrypto">更多产品<em /></p>
              </div>
              <div class="itemUl">
                <ul>
                  <li v-for="product in filterCryptoList" :key="'crypto-' + product.code" :class="{checked:code==product.code}" @click="selectType(product)"><span>{{ product.chname }}</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="submit" @click="submit"><span>确认</span></div>
        </div>
      </div>
    </div>
    <Time v-if="isTime" :show="isTime" @change="change" @cancel="cancel" />
  </div>
</template>

<script>
require('@/assets/css/tickData.css')
import Header from '@/view/module/Header.vue'
import Time from '@/view/tickData/Time.vue'
import noData from '@/view/module/noData.vue'
import utils from '@/utils/tradeDataUtil'
import api from '@/plugins/api'
import '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
export default {
  name: 'TickData',
  components: { Header, Time, noData },
  data() {
    return {
      title: '历史分笔数据',
      rightContent: 'report',
      isScroll: '',
      Utils: utils,
      isForeign: false,
      isTime: false,
      timeData: '',
      fxList: '', // 外汇列表
      originalFxList: '', // 原始外汇列表
      goodsList: '', // 商品列表
      originalGoodsList: '', // 原始商品列表
      indicesList: '', // 指数列表
      originalIndicesList: '', // 原始指数列表
      stocksList: '', // 股票列表
      originalStocksList: '', // 原始股票列表
      cryptoList: [],
      foreignIndex: -1,
      goodsIndex: -1,
      indicesIndex: -1,
      stocksIndex: -1,
      code: '',
      enname: '',
      chname: '',
      seqCode: '',
      opertor: '',
      timeZone: '',
      firstSeqCode: '',
      isPre: false,
      lastSeqCode: '',
      isNext: false,
      digit: '',
      quoteList: '',
      oldQuoteList: '',
      moreTxt: '',
      isPosition: false,
      maxHeight: '',
      showAllFx: false,
      showAllGoods: false,
      showAllIndexs: false,
      showAllCrypto: false,
      showAllStocks: false,
      accountLevel: ''
    }
  },
  computed: {
    ...mapState(['tickData', 'gts2CustomerId']),
    filteredFxList: function() {
      // if (this.showAllFx) return this.fxList
      // else return this.fxList.slice(0, 6)
      return this.showAllFx ? this.fxList : this.fxList.slice(0, 6)
    },
    filteredGoodsList: function() {
      return this.showAllGoods ? this.goodsList : this.goodsList.slice(0, 6)
    },
    filteredIndexList: function() {
      return this.showAllIndexs ? this.indicesList : this.indicesList.slice(0, 6)
    },
    filteredStockList: function() {
      return this.showAllStocks ? this.stocksList : this.stocksList.slice(0, 6)
    },
    filterCryptoList: function() {
      return this.showAllCrypto ? this.cryptoList : this.cryptoList.slice(0, 6)
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    this.getAccTradeInfo()
    // this.initQuoteProduct()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    hasScrollbar() {
      const height = window.innerHeight || document.documentElement.clientHeight
      const navHeight = document.getElementById('navTitle').clientHeight
      const filterHeight = document.getElementById('filterCon').clientHeight
      this.maxHeight = height - navHeight - (2 * filterHeight) + 'px'
      if (document.body.scrollHeight > height) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    classType(obj) {
      let val
      if (obj == 'red') {
        val = 'rise'
      } else if (obj == 'green') {
        val = 'fall'
      }
      return val
    },
    timeZones(val) {
      if (!val) return ''
      if (val) {
        const localTime = utils.getLocalTime(8, val)
        return new Date(localTime).format('Y-MM-dd hh:mm:ss')
      }
    },
    showSub(type) {

    },
    selectTime() {
      this.isTime = true
    },
    change(data) {
      this.timeData = data.format('Y-MM-dd hh:mm:ss')
      this.productList()
    },
    cancel(show) {
      this.isTime = show
    },
    foreignPop() {
      this.toggleFixed()
      this.isForeign = !this.isForeign
    },
    getAccTradeInfo() {
      api
        .getAccTradeInfo(this.gts2CustomerId)
        .then((res) => {
          if (res.status === 200 && res.data.code === 200) {
            this.accountLevel = res.data.data.accTradeInfoList[0].accountLevel
            this.initQuoteProduct()
            return
          }
          this.$toast.warning('资料获取失败')
        })
        .catch(() => {
          this.$toast.fail('资料获取失败')
        })
    },
    getQuoteProductsByAccountLevel(products) {
      if (this.accountLevel == 'EXC') {
        return {
          fxList: products.fxList,
          goodsList: products.goodsList.filter(good => !['022', '222', '023', '223', '351'].includes(good.code)),
          stocksList: products.stocksList,
          indicesList: products.indicesList.filter(index => !['357'].includes(index.code)),
          cryptoList: products.cryptoList.filter(crypto => !['675'].includes(crypto.code))
        }
      }

      if (['STP', 'ECN'].includes(this.accountLevel)) {
        return {
          fxList: products.fxList,
          goodsList: products.goodsList.filter(good => !['022', '602', '627', '023', '605', '628', '629'].includes(good.code)),
          stocksList: products.stocksList,
          indicesList: products.indicesList.filter(index => !['630'].includes(index.code)),
          cryptoList: products.cryptoList.filter(crypto => !['675'].includes(crypto.code))
        }
      }

      return {
        fxList: products.fxList,
        goodsList: products.goodsList.filter(good => !['222', '627', '223', '628', '629'].includes(good.code)),
        stocksList: products.stocksList,
        indicesList: products.indicesList.filter(index => !['630'].includes(index.code)),
        cryptoList: products.cryptoList.filter(crypto => !['675'].includes(crypto.code))
      }
    },
    initQuoteProduct() {
      api.getQuoteProduct().then(res => {
        if (res.data.code == 200) {
          const data = this.getQuoteProductsByAccountLevel(
            // Map zhishuList to indicesList and usStocksList to stocksList
            (({ zhishuList: indicesList, usStocksList: stocksList, ...rest }) => ({ indicesList, stocksList, ...rest }))(res.data.data)
          )
          
          this.fxList = data.fxList
          this.goodsList = data.goodsList
          this.stocksList = data.stocksList
          this.indicesList = data.indicesList
          this.cryptoList = data.cryptoList
          this.code = this.fxList[0].code
          this.chname = this.fxList[0].chname
          this.enname = this.fxList[0].enname
          const tickData = {
            gmcode: this.fxList[0].code,
            enname: this.fxList[0].enname,
            chname: this.fxList[0].chname,
            digit: this.fxList[0].digit
          }
          this.$store.dispatch('setTickData', tickData)
          this.isPositionData()
          this.initTime()
        }
      })
    },
    initTime() {
      api.getDefaultTime().then(res => {
        if (res.data.code == 200) {
          this.timeData = res.data.data.defaultTime
          this.productList()
        }
      })
    },
    isPositionData() {
      const data = {
        gmcode: this.tickData.gmcode,
        enname: this.tickData.enname
      }
      api.judgePosition(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.position) this.isPosition = true
          else this.isPosition = false
        }
      })
    },
    selectType(data) {
      this.code = data.code
      this.enname = data.enname
      this.chname = data.chname
      const tickData = {
        gmcode: data.code,
        enname: data.enname,
        chname: data.chname,
        digit: data.digit
      }
      this.$store.dispatch('setTickData', tickData)
      this.isPositionData()
    },
    queryQuote(data, type) {
      api.queryQuoteList(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          this.$bus.$emit('loading', true)
          this.isForeign = false
          this.removeFixed()
          this.firstSeqCode = res.data.data.firstSeqCode
          this.lastSeqCode = res.data.data.lastSeqCode
          this.quoteList = res.data.data.quoteList
          if (type == -1) {
            if (utils.isNotEmpty(this.firstSeqCode)) this.isPre = true
            else this.isPre = false
            if (utils.isNotEmpty(this.lastSeqCode) && this.quoteList.length >= 20) this.isNext = true
            else this.isNext = false
          } else if (type == 0) {
            this.isNext = true
            if (utils.isNotEmpty(this.firstSeqCode) && this.quoteList.length >= 20) this.isPre = true
            else this.isPre = false
          } else if (type == 1) {
            this.isPre = true
            if (utils.isNotEmpty(this.lastSeqCode) && this.quoteList.length >= 20) this.isNext = true
            else this.isNext = false
          }
        }
      })
    },
    clickPre() {
      if (utils.isNotEmpty(this.firstSeqCode)) {
        this.$bus.$emit('loading', false)
        const data = {
          dateTime: new Date(this.timeData.replace(/-/g, '/')).getTime(),
          gmcode: this.tickData.gmcode,
          seqCode: this.firstSeqCode,
          opertor: 'pre',
          timeZone: '8',
          enname: this.tickData.enname,
          digit: this.tickData.digit
        }
        this.queryQuote(data, 0)
      }
    },
    clickNext() {
      if (utils.isNotEmpty(this.lastSeqCode)) {
        this.$bus.$emit('loading', false)
        const data = {
          dateTime: new Date((this.timeData).replace(/-/g, '/')).getTime(),
          gmcode: this.tickData.gmcode,
          seqCode: this.lastSeqCode,
          opertor: 'next',
          timeZone: '8',
          enname: this.tickData.enname,
          digit: this.tickData.digit
        }
        this.queryQuote(data, 1)
      }
    },
    productList() {
      this.$bus.$emit('loading', false)
      const data = {
        dateTime: new Date((this.timeData).replace(/-/g, '/')).getTime(),
        gmcode: this.tickData.gmcode,
        timeZone: '8',
        enname: this.tickData.enname,
        digit: this.tickData.digit
      }
      this.queryQuote(data, -1)
    },
    flashProductList() {
      this.$bus.$emit('loading', false)
      this.initTime()
      this.isPositionData()
    },
    submit() {
      this.$bus.$emit('loading', false)
      this.productList()
    }
  }
}
</script>
